import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQuarkusComponent } from './simple-icons-quarkus.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQuarkusComponent ],
    exports:      [ SimpleIconsQuarkusComponent ],
    bootstrap:    []
})
export class SimpleIconsQuarkusModule {}
